import {
  COMMON_INPUT,
  BASE_LAYER_CHANGE,
  DISPLAY_BASELAYER_PANEL,
  DISPLAY_ABOUT_MODAL,
} from "../types";
import urls from "../../urls";
import axios from "axios";
import domain from "../../domain";
export const common_state = () => (dispatch, getState) => {
  dispatch({
    type: COMMON_INPUT,
  });
};

export const changeBaseLayer = (event) => (dispatch, getState) => {
  let layers, url;

  if (event.target.value === "Map") {
    url = urls.bhuvan_map;
    layers = urls.map_layer;
  } else if (event.target.value === "Satellite") {
    layers = urls.s_layer;

    url = urls.satellite;
  }
  dispatch({
    type: BASE_LAYER_CHANGE,
    baselayerselected: event.target.value,
    url: url,
    layers: layers,
  });
};

export const displayBaseLayerPanel = () => (dispatch, getState) => {
  dispatch({
    type: DISPLAY_BASELAYER_PANEL,
    baselayers: !getState().CState.baseLayers,
  });
};
export const displayAboutModal = () => (dispatch, getState) => {
  dispatch({
    type: DISPLAY_ABOUT_MODAL,
    payload: !getState().CState.modal,
  });
};

export const fetchAllDates = () => async (dispatch, getState) => {
  let result = await axios.get(`${domain.DBServer}/get-avail-dates-all`);
  console.log(result);
};
